/*
  全局公共组件，自动扫描加载
  Date_: 2019-05-08 14:27:54
*/

import Vue from "vue";

const requireComponent = require.context("./", true, /\.vue/);

console.log('components')

requireComponent.keys().forEach(fileName => {
  const config = requireComponent(fileName);
  Vue.component(config.default.name, config.default || config);
});